fx.ns("shared.screens", class CoverAlbum extends shared.screens.BaseChoiceScreen 
    {    
        constructor()
        {
            super();
    
            this.showNext = false;
            this.showBack = fx.get("mode") == "creating";

            this.styleChoice = "circle";

            this.containerHeight = 450;

            this.title = fx.text("Choisissez la finition de votre album");
        }

        get currentCover()
        {
            return (fx.get("mode") == "creating") ? this.data.choosedCover : this.data.creation.optionid;
        }

        // asked by the order button, after the preview : hard and layflat are listed side by
        // side and picking a cover applies it directly, without the opening type screen
        get preOrder()
        {
            return fx.get("mode") != "creating" && !!this.data.preOrderChoices;
        }

        // order flow, cover already picked : an invitation to a pricier one - current cover
        // pointed out, skip allowed, price differences
        get upgradeMode()
        {
            return this.preOrder && !this.data.coverChoicePending;
        }

        // a customer who never picked his cover has to pick one now
        get canSkip()
        {
            return !this.data.coverChoicePending;
        }
        
        create()
        {
            super.create();
    
            if (this.data.creation.coverChoices.length == 0)
            {
                this.loading(true, fx.text("Chargement"));
                this.data.creation.coverChoices.load();
            }
            else
                this.build();
        }
    
        onDataEvent(event)
        {
            if (event.type == "cover-option-loaded")
                this.build();
        }
    
        build() 
        {    
            let options = [];

            if (this.upgradeMode)
            {
                this.title = fx.text("Souhaitez-vous sublimer votre album ?");
                options = this.data.creation.coverUpgradeChoices();
            }
            else if (this.preOrder)
            {
                this.title = fx.text("Sélectionnez la couverture de votre album");
                options = this.data.creation.coverChoicesToPick();
            }
            else
            {
                // the shape / size couple only describes the album being created, once it exists
                // the covers are the ones of its format
                let choices = (fx.get("mode") == "creating" && this.data.choosedSize) ? this.data.creation.availableCoverChoicesForShapeSize( this.data.choosedShape, this.data.choosedSize ) : this.data.creation.availableCoverChoices(fx.get("mode") == "creating" ? this.data.choosedFormat : this.data.creation.formatid);
                // cheapest first, at the album page count
                choices = choices.sort((a, b) => this.data.creation.calculatePrice(a, true, true) - this.data.creation.calculatePrice(b, true, true));

                for(let i = 0; i < choices.length; i++)
                {
                    let option = choices.getItemAt(i);

                    // layflat is picked on the opening type screen that follows the hard cover
                    if (option.cover.editor_code == models.ProductBook.LAYFLAT)
                        continue;

                    // from the info panel every cover of the format is offered, the stapled one
                    // included : only the order flow keeps it for the stapled notebook product
                    options.push(option);
                }
            }

            // order flow : the album price with each cover
            let prices = null;
            if (this.preOrder)
            {
                prices = {};
                for (let i = 0; i < options.length; i++)
                    prices[options[i].option_id] = this.data.creation.calculatePrice(options[i], true, true);
            }

            super.build();

            // "Top Vente" goes on the layflat cover, or on the hard one when layflat is not
            // listed - never on both
            let topSale = null;
            for (let i = 0; i < options.length; i++)
                if (options[i].cover.editor_code == models.ProductBook.LAYFLAT || (options[i].cover.editor_code == models.ProductBook.HARD && !topSale))
                    topSale = options[i].cover.editor_code;

            // never picked : every cover shows the album price. Already picked : only what each
            // cover changes to it
            let reference = prices && this.upgradeMode ? prices[this.currentCover] : undefined;

            for(let i = 0; i < options.length; i++)
            {
                let option = options[i];

                // layflat is only listed in the order flow : name it for what it adds to the hard cover
                let name = option.cover.editor_code == models.ProductBook.LAYFLAT ? fx.text("Album Rigide + Ouverture à plat") : option.cover.shortname;
                let price = prices ? (reference === undefined ? this.orderPriceLabel(prices[option.option_id]) : this.orderPriceDifference(prices[option.option_id] - reference)) : fx.text("A partir de <strong>$</strong>", this.data.creation.calculatePrice(option));
    
                let choice = new shared.components.ProductChoice("circle", option, this.data.creation.getOptionAsset(option), name, fx.text("De $ à $ pages", option.min_pages,  option.max_pages), price);

                // the current cover is only pointed out when we invite to upgrade
                if (this.upgradeMode && this.currentCover == option.option_id)
                    choice.addClass("selected");

                if (option.cover.editor_code == topSale)
                    choice.badge = fx.text("Top Vente");

                if (prices && reference === undefined)
                    choice.addClass("album-price");
    
                this.addChoice(choice, fx.browser.isDesktop ? {width: 190, height : 350} : {width: 190, height : 350, left : "center"})
            }
                
            this.loading(false);
        }
    
    
        onChoiceClicked(coverObj)
        {
            let cover = coverObj.cover.editor_code;

            if (this.preOrder) // hard and layflat are listed side by side : no opening type step
            {
                this.data.book.updateCover(coverObj);

                if (this.data.book.optionid == coverObj.option_id) // refused when the page count does not fit
                {
                    this.data.coverChoicePending = false;
                    this.data.event("creation-choice-done");
                }

                return;
            }
			
            if (cover == "hard")
            {
                if (fx.get("mode") == "creating")
                    this.data.event("next-step")
                else
                    this.trigger("next-step");
            }
            else
            {
                if (fx.get("mode") == "creating")
                {
                    this.data.choosedCover = cover;
                    this.data.event("step-Splash");
                }
                else
                {
                    this.data.book.updateCover(coverObj);

                    // updateCover refuses a cover the album has too many / too few pages for
                    if (this.data.book.optionid == coverObj.option_id)
                        this.data.coverChoicePending = false;

                    this.trigger("reset-navigation");
                }
            }  
        }
    
    });
